import React from 'react';

/**
 * Mandate — 4-step engagement path on dark anthracite background.
 * Pass `onCTA` to wire the bottom link. Auto-numbered when inside `.numbered-sections`.
 * Section element has id="mandat" so it remains a valid scroll target.
 */
export default function Mandate({ onCTA }) {
  const steps = [
    { n: '01', title: 'Anfrage', desc: 'Sie kontaktieren uns vertraulich.' },
    { n: '02', title: 'Vorgespräch', desc: '20 Min. — wechselseitige Eignung per Telefon.' },
    { n: '03', title: 'Erstanalyse', desc: '60 Min. — strukturierte Bestandsaufnahme.' },
    { n: '04', title: 'Mandatsangebot', desc: 'Individueller Vertragsentwurf.' },
  ];

  return (
    <section id="mandat" style={{ padding: '140px 0', background: 'var(--anthracite)', color: 'var(--cream)' }}>
      <div className="shell">
        <div
          className="section-label numbered reveal"
          style={{ marginBottom: 28, color: 'rgba(245,242,236,0.55)' }}
        >
          <span style={{ color: 'rgba(245,242,236,0.55)' }}>Mandat</span>
        </div>
        <h2 className="h-section reveal" style={{ color: 'var(--cream)', marginBottom: 36 }}>
          Das Mandat.
        </h2>
        <p className="body-prose reveal" style={{ color: 'rgba(245,242,236,0.78)', fontSize: 19, marginBottom: 88 }}>
          Wir nehmen jährlich nur eine begrenzte Zahl neuer Mandate an. Voraussetzung: Große Objekte oder Portfolios im Rhein-Main-Gebiet.
        </p>

        <div
          className="reveal"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 0,
            borderTop: '1px solid rgba(245,242,236,0.14)',
            borderBottom: '1px solid rgba(245,242,236,0.14)',
          }}
        >
          {steps.map((s, i) => (
            <div
              key={i}
              style={{
                padding: '32px 28px',
                borderRight: i < steps.length - 1 ? '1px solid rgba(245,242,236,0.14)' : 'none',
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
              }}
            >
              <div
                style={{
                  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                  fontSize: 11,
                  letterSpacing: '0.16em',
                  color: 'rgba(245,242,236,0.45)',
                  marginBottom: 12,
                }}
              >
                {s.n}
              </div>
              <div
                style={{
                  fontFamily: 'var(--serif)',
                  fontSize: 22,
                  color: 'var(--cream)',
                  lineHeight: 1.2,
                  minHeight: '2.4em',
                }}
              >
                {s.title}
              </div>
              <div style={{ fontSize: 14, color: 'rgba(245,242,236,0.6)', lineHeight: 1.5 }}>
                {s.desc}
              </div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 56 }}>
          <a
            href="#form"
            className="tlink"
            style={{ color: 'var(--cream)' }}
            onClick={(e) => { e.preventDefault(); onCTA?.(); }}
          >
            Erstanalyse anfragen <span className="arrow">→</span>
          </a>
        </div>
      </div>
    </section>
  );
}
